import { render, staticRenderFns } from "./adminRequests.vue?vue&type=template&id=1f2277ee&scoped=true&"
import script from "./adminRequests.vue?vue&type=script&lang=js&"
export * from "./adminRequests.vue?vue&type=script&lang=js&"
import style0 from "./adminRequests.vue?vue&type=style&index=0&id=1f2277ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2277ee",
  null
  
)

export default component.exports